import {Component, OnInit, ViewChild} from '@angular/core';
import {HttpService} from '../../../services/http.service';
import {WarrantyList} from '../../../models/warranties/warranty-list.model';
import {Filter} from '../../../models/warranties/filter.model';
import {ContractTypeDistinctModel} from '../../../models/warranties/contract-type-distinct.model';
import {FilterService} from '../../warranty-list/filter-service';
import {DecimalUtil} from '../../commons/util/decimal-util';


@Component({
  selector: 'app-warranty-list',
  templateUrl: './admin-warranty-list.component.html',
  styleUrls: ['./admin-warranty-list.component.scss']
})
export class AdminWarrantyListComponent implements OnInit {

  @ViewChild('removePage') removePage: HTMLInputElement;
  @ViewChild('addPage') addPage: HTMLInputElement;

  constructor(private http: HttpService, private filterService: FilterService, public decimalUtil: DecimalUtil) {
  }

  warrantyList: WarrantyList = new WarrantyList();
  contractTypes: ContractTypeDistinctModel[] = [];
  dashCounts: any[] = [];

  ngOnInit(): void {
    this.fetchContractTypes();
    this.refreshList();
    this.fetchDashboardCounts();
  }

  fetchContractTypes() {
    this.http.fetchDistinctContractTypes().subscribe((res) => {
      this.contractTypes = res;
    });
  }

  refreshList() {
    this.http.fetchAdminWarranties(this.getFilter()).subscribe((res: WarrantyList) => {
      this.warrantyList = Object.assign(new WarrantyList(), res);
    });
  }

  fetchDashboardCounts() {
    this.http.fetchDashCounts().subscribe((res: any) => {
      this.dashCounts = res;
    });
  }

  getCountForType(status: string): number {
    let d = this.dashCounts.find(d => d.status == status);
    if (d) return d.count;
    else return 0;
  }

  filterByStatus(status: string) {
    this.getFilter().status = status;
    this.refreshList();
  }

  orderBy(field: string) {
    if (this.getFilter().orderBy == field) {
      if (this.getFilter().order == 'ASC')
        this.getFilter().order = 'DESC';
      else this.getFilter().order = 'ASC';
    }
    this.getFilter().orderBy = field;
    this.refreshList();
  }

  showDirectionImage(): string {
    if (this.getFilter().order == 'ASC') return 'assets/images/icon-sort-up.png';
    else return 'assets/images/icon-sort-down.png';
  }

  clearFilter() {
    this.filterService.resetDashboardFilter();
    this.refreshList();
  }

  changePage(count: number) {
    this.getFilter().page += count;
    this.refreshList();
  }

  getFilter(): Filter {
    return this.filterService.getDashboardFilter();
  }

}
